// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"x_","link":"ya","linkText":"yb","linkIcon":"yc","isRental":"yd","active":"ye","synopsisAndButton":"yf","linkWrapper":"yh"};